export default __webpack_public_path__ + "img/ad5fdb2f0bf019c0ae12b8f27678e75d.svg";